"use client"

import { memo } from "react"
import CategoryUnderline from '@/components/ui/CategoryUnderline'
import { catColor } from '@/lib/catColors'
import { getCategoryNames, getCategoryNamesEnglish } from "@/lib/helper"
import Link from "next/link"
import CustomImage from "@/components/ui/CustomImage"
import { useAuth } from "@/contexts/AuthContext"
import { GRID_COUNTS, take } from "@/lib/gridCounts"

const RANK_COLORS = ['#B71C1C', '#E64A19', '#F9A825', '#2E7D32', '#1565C0']

const TrendingModule = ({ 
	items,
	label = 'ट्रेंडिंग',
	isBgColor,
	url = "/trending",
	viewAll = true,
}) => {
	const { categories } = useAuth();
	const visibleItems = take(items, GRID_COUNTS.TRENDING)

	return (
		<section className={isBgColor ? 'bg-white border border-(--border-default) rounded-lg p-3 sm:p-4 shadow-sm' : ''}>
			<CategoryUnderline
				name="Maharashtra"
				label={label}
				url={url}
				viewAll={viewAll}
			/>

			<ol className="list-none m-0 p-0">
				{visibleItems.map((item, i) => (
					<li
						key={item.id || i}
						className={`grid grid-cols-[40px_1fr_72px] sm:grid-cols-[44px_1fr_80px] gap-2.5 sm:gap-3 py-2.5 items-center ${
							i < visibleItems.length - 1 ? 'border-b border-(--border-default)' : ''
						}`}
					>
						<div
							className="w-10 h-10 rounded-md flex items-center justify-center text-white text-lg sm:text-xl font-black shrink-0"
							style={{
								background: RANK_COLORS[i] ?? 'var(--brand-primary)',
								boxShadow: `0 2px 6px ${RANK_COLORS[i] ?? 'var(--brand-primary)'}55`,
							}}
						>
							{i + 1}
						</div>

						<div className="min-w-0">
							{(() => {
								const categoryName = getCategoryNames(item.categoryIds, categories)
								const categorySlug = getCategoryNamesEnglish(item.categoryIds, categories)
								const nameLabel = Array.isArray(categoryName) ? categoryName[0] : categoryName
								const slugLabel = Array.isArray(categorySlug) ? categorySlug[0] : categorySlug
								if (!nameLabel || !slugLabel) return null
								return (
									<Link
										href={`/category/${slugLabel}`}
										className="mr text-[11px] font-bold uppercase tracking-wider mb-1 block"
										style={{ color: catColor(nameLabel) }}
									>
										{nameLabel}
									</Link>
								)
							})()}

							<Link
								href={`/news/${item.slug}`}
								className="mr m-0 text-sm font-semibold overflow-hidden line-clamp-2 hover:text-(--brand-primary) transition-colors"
							>
								{item.title}
							</Link>
						</div>

						<Link href={`/news/${item.slug}`} className="block overflow-hidden rounded-md shrink-0">
							<CustomImage
								src={item.featuredImage}
								alt={item.title}
								width={80}
								height={56}
								className="w-[72px] sm:w-20 h-14 object-cover"
							/>
						</Link>
					</li>
				))}
			</ol>
		</section>
	)
}

export default memo(TrendingModule)
